import React, { createContext, useContext, useState } from "react";

// Create a Context for carInfo
const GeneralInfoContext = createContext();

// Custom hook to use the CarInfo context
export const useGeneralInfo = () => useContext(GeneralInfoContext);

// Provider component
export const GeneralInfoProvider = ({ children }) => {
  const [generalInfo, setGeneralInfo] = useState({
    makes: [],
    models: [],
    model: [],
    cities: [],
    cars: [],
  });

  return (
    <GeneralInfoContext.Provider value={[generalInfo, setGeneralInfo]}>
      {children}
    </GeneralInfoContext.Provider>
  );
};
